import { Content } from "antd/es/layout/layout";
import { NarrowPageContentContainer } from "@vyne-shared/components/vyneNavigation/PageContentContainers";
import { Outlet, createRootRoute } from "@tanstack/react-router";
import { PageHeader } from "components/Navigation/pageHeader/PageHeader";
import { ReactQueryDevtools } from "@tanstack/react-query-devtools";
import { Result } from "antd";
import { TanStackRouterDevtools } from "@tanstack/react-router-devtools";

/** The layout for payments dashboard. */
export const Route = createRootRoute({
    component: RootRoute,
    notFoundComponent: () => (
        <NarrowPageContentContainer>
            <Result
                status="404"
                title="Not found"
                subTitle="We couldn't find the page you're looking for. Please try the main menu on the left."
            />
        </NarrowPageContentContainer>
    ),
});

function RootRoute() {
    return (
        <>
            <PageHeader />
            <Content>
                <Outlet />
            </Content>
            <TanStackRouterDevtools initialIsOpen={false} />
            <ReactQueryDevtools initialIsOpen={false} />
        </>
    );
}
